exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Header-___styles__headerContainer___107Be {\n  padding: 10px;\n  background-color: #FFF;\n  border-bottom: 2px solid #dedad1\n}\n.src-components-Header-___styles__headerContainer___107Be img {\n    width: 170px;\n    margin: 0px 10px 2px 10px;\n  }", ""]);

// Exports
exports.locals = {
	"headerContainer": "src-components-Header-___styles__headerContainer___107Be"
};